module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-bar"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "search..."
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-440393ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar.vue
// module id = 151
// module chunks = 1